// Location: src/features/devices/validators/deviceValidators.ts

/**
 * Validation functions for Device forms
 */

/**
 * Validate installation code format
 * Expected format: alphanumeric with dots and dashes (e.g., "KR250101.1", "DISP-001")
 */
export const validateInstallationCode = (value: string): string | undefined => {
  if (!value || value.trim() === '') {
    return 'devices.validation.installationCodeRequired';
  }

  // Check minimum length
  if (value.length < 3) {
    return 'devices.validation.installationCodeTooShort';
  }

  // Check maximum length
  if (value.length > 50) {
    return 'devices.validation.installationCodeTooLong';
  }

  // Allow alphanumeric, dots, dashes, and underscores
  const validPattern = /^[a-zA-Z0-9._-]+$/;
  if (!validPattern.test(value)) {
    return 'devices.validation.installationCodeInvalidFormat';
  }

  return undefined;
};

/**
 * Validate hotel ID is selected
 */
export const validateHotelId = (value: string): string | undefined => {
  if (!value || value.trim() === '') {
    return 'devices.validation.hotelRequired';
  }
  return undefined;
};

/**
 * Validate device type is selected
 */
export const validateDeviceType = (value: string): string | undefined => {
  if (!value || value.trim() === '') {
    return 'devices.validation.deviceTypeRequired';
  }

  const validTypes = ['Kiosk', 'Dispenser', 'Mobile', 'Online'];
  if (!validTypes.includes(value)) {
    return 'devices.validation.deviceTypeInvalid';
  }

  return undefined;
};



/**
 * Validate channel is selected
 */
export const validateChannel = (value: string): string | undefined => {
  if (!value || value.trim() === '') {
    return 'devices.validation.channelRequired';
  }

  const validChannels = ['Kiosk', 'Dispenser', 'Online', 'AirLobby', 'MobileKiosk'];
  if (!validChannels.includes(value)) {
    return 'devices.validation.channelInvalid';
  }

  return undefined;
};

/**
 * Combined validation for device creation form
 */
export const validateDeviceCreate = (values: any): Record<string, any> => {
  const errors: Record<string, any> = {};

  const installationCodeError = validateInstallationCode(values.installationCode);
  if (installationCodeError) {
    errors.installationCode = installationCodeError;
  }

  const hotelIdError = validateHotelId(values.hotelId);
  if (hotelIdError) {
    errors.hotelId = hotelIdError;
  }

  const deviceTypeError = validateDeviceType(values.deviceType);
  if (deviceTypeError) {
    errors.deviceType = deviceTypeError;
  }

  const channelError = validateChannel(values.channel);
  if (channelError) {
    errors.channel = channelError;
  }

  return errors;
};






